import { act_com } from '@lc/action/cardType/Common';
import { act_event } from '@lc/action/cardType/Event';
// import { EventMeta } from '@lc/card/meta/ss/EventMeta';
import { createCardEventVerbose } from '@lc/interface/card/event/factory';
import { Event } from '@lc/interface/card/event/types';
import { GameState } from '@lc/interface/gameState/types';

export const getEventVerbose = (EventMeta: Event[]) => [
	createCardEventVerbose(
		EventMeta[0],
		(
			playerData: any,
			gameState: GameState // 40
		) => act_com.rechargeBattery(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[1],
		(
			playerData: any,
			gameState: GameState // 41
		) => act_com.rechargeBattery(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[2],
		(
			playerData: any,
			gameState: GameState // 42
		) => act_com.rechargeBattery(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[3],
		(
			playerData: any,
			gameState: GameState // 43
		) => act_com.drawCards(playerData, gameState, 3)
	),
	createCardEventVerbose(
		EventMeta[4],
		(
			playerData: any,
			gameState: GameState // 44
		) => act_com.drawCards(playerData, gameState, 3)
	),
	createCardEventVerbose(
		EventMeta[5],
		(
			playerData: any,
			gameState: GameState // 45
		) => act_event.forceDonation(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[6],
		(
			playerData: any,
			gameState: GameState // 46
		) => act_com.drawCards(playerData, gameState, 3)
	),
	createCardEventVerbose(
		EventMeta[7],
		(
			playerData: any,
			gameState: GameState // 47
		) => act_com.stealDonation(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[8],
		(
			playerData: any,
			gameState: GameState // 48
		) => act_com.notPlayable(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[9],
		(
			playerData: any,
			gameState: GameState // 49 TODO Needs to put forward a payment, so apply a modifier to player?
		) => act_com.notPlayable(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[10],
		(
			playerData: any,
			gameState: GameState // 50 TODO Needs to put forward a payment, so apply a modifier to player?
		) => act_com.moveCarbonForPR(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[11],
		(
			playerData: any,
			gameState: GameState // 51
		) => act_com.reduceTargetPR(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[12],
		(
			playerData: any,
			gameState: GameState // 52
		) => act_com.reduceTargetPR(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[13],
		(
			playerData: any,
			gameState: GameState // 53
		) => act_com.rechargeBattery(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[14],
		(
			playerData: any,
			gameState: GameState // 54
		) => act_event.carbonDating(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[15],
		(
			playerData: any,
			gameState: GameState // 55
		) => act_com.stealCardForEnergy(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[16],
		(
			playerData: any,
			gameState: GameState // 56
		) => act_com.terminateBattery(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[17],
		(
			playerData: any,
			gameState: GameState // 57
		) => act_com.stealEnergy(playerData, gameState)
	),
];
